import * as React from 'react';
import { IArticleListItem } from '../shared/shared-types';
import { SearchArticleListItem } from './search-article-list-item';

export interface ISearchArticleListProps {
    isLoading: boolean,    
    searchString: string,
    trackingId: string,
    articles: Array<IArticleListItem>,
    pageSize: number,
    adPosition: number,
    articleListAds: Array<HTMLElement>
}

export class SearchArticleList extends React.Component<ISearchArticleListProps, {}>{    

    constructor(props: ISearchArticleListProps) {
        super(props);
        this.onClickHandler = this.onClickHandler.bind(this);
    }

    get isFullList(): boolean {
        return this.props.articles.length >= this.props.pageSize;
    }

    public onClickHandler(hitId: string): void {

        if (hitId) {

            const hitJson = JSON.stringify({
                searchString: this.props.searchString,
                trackingId: this.props.trackingId,
                hitId: hitId
            });

            let cookie = `SearchHit=${hitJson};path=/`;
            document.cookie = cookie;
        }

    }

    private getArticleList(): JSX.Element[] {

        const articleList = this.props.articles.map(x =>
            <SearchArticleListItem
                key={`${x.id}:${x.language}`}
                item={x}
                searchString={this.props.searchString}
                onClickHandler={this.onClickHandler} />);

        const adBlocks = [...this.props.articleListAds];        
        if (adBlocks.length) {

            let position: number = 1;

            // Only insert ad if full list
            if (this.isFullList) {       
                const firstAdBlock = adBlocks.shift();      
                articleList.splice(this.props.adPosition, 0, this.getArticleListAdBlock(firstAdBlock, position));
                position++;
            }

            // Append ad block to bottom
            if (adBlocks.length) {
                const bottomAdBlock = adBlocks.shift();
                articleList.push(this.getArticleListAdBlock(bottomAdBlock, position));
            }
        }
        return articleList;
    }

    private getArticleListAdBlock(adBlock: HTMLElement, position: number): JSX.Element {

        const html = { __html: adBlock.outerHTML };
        return <div key={`ad:${position}`} className="article-list-item search-listing-item ad" dangerouslySetInnerHTML={html}></div>

    }

    render() {

        const className = 'article-list search-listing';
        if (this.props.isLoading) {

            return (
                <div className={className}>
                    <p>Loading...</p>
                </div>
            );

        } else if (this.props.articles.length) {

            return (
                <div className={className}>
                    {this.getArticleList()}
                </div>
            );

        }

    }
}


// WEBPACK FOOTER //
// ./~/source-map-loader!./app/src/slp/search-article-list.tsx